import Vue from 'vue'
import App from './App.vue'
import {router} from './route'
import ElementUI from 'element-ui';
import store from './store'
import Vant from 'vant';
import Antd from "ant-design-vue";
// import VConsole from 'vconsole';
import vueEsign from "vue-esign";
import dayjs from 'dayjs'
// import 'amfe-flexible'
// import 'amfe-flexible/index.js'
// import echarts from 'echarts'
import  * as echarts from "echarts"
import 'vant/lib/index.css';
import 'element-ui/lib/theme-chalk/index.css';
import 'ant-design-vue/dist/antd.css';
import './assets/iconfont/iconfont.css'
import './assets/newIconfont/iconfont.css'
// import './jurisdiction.js'
// import './router'
Vue.config.productionTip = false
// const vConsole = new VConsole();
console.log(document.documentElement.style.fontSize);
function setRem() {
				var documentElement = document.documentElement;
				function callback() {
					var clientWidth = documentElement.clientWidth;
					// 屏幕宽度大于780，不在放大
					// clientWidth = clientWidth < 780 ? clientWidth : 780;
					documentElement.style.fontSize = clientWidth / 10 + 'px';
					console.log(documentElement.style.fontSize);
				}
				document.addEventListener('DOMContentLoaded', callback);
				window.addEventListener('orientationchange' in window ? 'orientationchange' : 'resize', callback);
			}
			setRem();
Vue.use(Antd);
Vue.use(ElementUI);
Vue.use(Vant);
Vue.use(vueEsign)
Vue.prototype.$echarts = echarts
Vue.prototype.$dayjs = dayjs;
new Vue({
	store,
  router,
  render: h => h(App),
}).$mount('#app')
